var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column pt-2 px-1 pb-1",staticStyle:{"flex-basis":"0","flex-grow":"1","gap":"1rem"}},[_vm._t("table-controls"),_c('div',{staticClass:"d-flex flex-column align-items-center",staticStyle:{"min-height":"0","flex":"1 1 0"}},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }